import getBG from '../../utils/utils';

export default {
    name: 'remote-training',
    data() {
        return {
            backgroundImage: '',
            content: ''
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.backgroundImage = await getBG.call(this, 'RemoteTraining');
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    contentType: 'homePageRemoteTraining'
                })
                .then(res => {
                    this.content = res[0].content;
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        }
    }
};
